/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import Tippy from '@tippyjs/react';
import Icon from '../../../_particles/icon/react/Icon';

type HeaderIconProps = {
  link: string,
  icon?: string,
  iconFilled?: string,
  label?: string,
  labelId: string,
  tooltip?: string,
  tooltipId?: string,
  className?: string,
  attributes?: any,
  initialFilled?: boolean,
};

const HeaderIcon = ({
  link,
  icon,
  iconFilled,
  label,
  labelId,
  tooltip,
  className,
  attributes,
  initialFilled,
}: HeaderIconProps): React$MixedElement => {
  const classes = [
    'header__icon',
    initialFilled ? 'header__icon--filled' : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const iconElement = (
    <a
      {...(attributes || {})}
      href={link}
      aria-labelledby={labelId}
      className={classes}
    >
      {icon && (
        <Icon
          icon={icon}
          ariaHidden={true}
          focusable={false}
          className="header__svg"
        />
      )}

      {iconFilled && (
        <Icon
          icon={iconFilled}
          ariaHidden={true}
          focusable={false}
          className="header__svg header__svg--filled"
        />
      )}

      {label && (
        <span id={labelId} className="header__icon-text" hidden>
          {label}
        </span>
      )}
    </a>
  );

  if (!tooltip) {
    return iconElement;
  }

  return (
    <Tippy
      content={tooltip}
      placement="bottom"
      animation="shift-away"
      arrow={false}
      theme="bw"
    >
      {iconElement}
    </Tippy>
  );
};

export default HeaderIcon;
